import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { ShufflePlaylistDocument } from './shuffle.generated';

export const useShufflePlaylist = (options: ApiOptions<typeof ShufflePlaylistDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(ShufflePlaylistDocument, {
    ...useNotifications(ShufflePlaylistDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.playlists.shuffle_success'),
    }),
    ...options,
  });
};
